<template>
  <div class="icon-select-box">
    <el-select
      v-model="select"
      multiple
      filterable
      allow-create
      :placeholder="placeholder"
      size="mini"
      class="field-value"
      @change="emit"
    >
      <el-option v-for="(val, i) in options" :key="i" :value="val" :label="val" />
    </el-select>
    <span class="select-icon"> <slot name="icon"></slot> </span>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
  },
  data() {
    return {
      select: [],
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.select = newValue
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    emit() {
      this.$emit('input', this.select)
    },
  },
}
</script>
<style>
.icon-select-box .el-input__suffix {
  display: none;
}
</style>
<style scoped>
.icon-select-box {
  display: flex;
  position: relative;
}
.select-icon {
  position: absolute;
  top: 0;
  right: 9px;
  color: #c0c4cc;
  font-size: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 100;
}
</style>
